import { faqTypes } from '../types/faqTypes'
import faqService from 'src/services/faq'
import { action } from 'typesafe-actions'

export const getAllFaqDataSuccess = (data: any) => {
  return {
    type: faqTypes.GET_FAQ_SUCCESS,
    payload: data,
  }
}

export const getAllFaqsAction = () => {
  return async (dispatch: any) => {
    dispatch(action(faqTypes.FAQ_IS_LOADING))

    try {
      const response: any = await faqService.faqAnswers()

      dispatch(action(faqTypes.GET_FAQ_SUCCESS, response.data.data))
      // dispatch(getAllFaqDataSuccess(response.data.data))
    } catch (error: any) {
      console.log(error.message)
    }
  }
}
